import _ from 'lodash';
import { auth, db } from '../../firebase';
import React, { Component } from 'react';
import moment from 'moment'
import request from 'request';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPencilAlt, faArrowAltCircleRight, faEnvelope, faFileCsv } from "@fortawesome/free-solid-svg-icons";
import stringWidth from "string-width"
import { CSVLink } from "react-csv";

import { addCheck, allCheck, deleteRecord } from '../../utils/common'

import Header from '../../components/header';
import Footer from '../../components/footer';
import Filter from '../../components/filter';

import menus from "../../data/menu.json";
import lots from "../../data/lot.json";
import signups from "../../data/signup.json";
import { user_templates } from "../../data/template.json";
import csv_headers from "../../data/csv_header.json";
const schedule_mst = {monday: "月", tuesday: "火", wednesday: "水", thursday: "木", friday: "金", saturday: "土", sunday: "日"}
const attribute_mst = {"0": "CP", "1": "定期"}

export default class AdminUsers extends Component {
  constructor (props) {
    super(props);

    this.state = {
      users: [],
      csv: [],
      casts: [],
      messages: [],
      emails: [],
      reservations: [],
      payments: [],
      user_name: "",
      user_picture: "",
      user: {},
      user_id: "",
      message: "",
      mail_title: "",
      mail_body: "",
      submenu: "lists",
      contentmenu: "message",
      date: moment().format('YYYY/MM/DD'),
      time: "9:00",
      lot: "30",
      menu: "1",
      price: "",
      period: 0,
      cast_id: "U9ce104f86bea7113e16904603cdeae28",
      caution: "",
      view_num: 100,
      alt: false,
      alt_text: "",
      sends: [],
      checks: {},
      all_check: "false",
      filter: "",
      users_tmp: []
    };
  }

  componentDidMount () {

    // ログイン確認
    var scope = this
    auth.onAuthStateChanged(function(user) {
      if (!user) {
        // No user is signed in.
        scope.props.history.push("/admin_login");
      } else {
        db.ref('casts').on('value', snapshot => {
          var casts = _.values(snapshot.val())
          scope.setState({ casts: casts })
        });

        db.ref('users').orderByChild("delete").equalTo(null).on('value', snapshot => {
          var users = _.values(snapshot.val())
          //console.log(users)
          for(let i in users) {
            users[i]["ref"] = "users/" + users[i].id
            if (!users[i].attribute) {
              users[i]["attribute"] = "1"
            }
            if (users[i].menu) {
              if (menus.find(menu => menu.id === users[i].menu)) {
                users[i]["menu"] = menus.find(menu => menu.id === users[i].menu).title
              }
              if (users[i].menu_etc) {
                users[i]["menu"] += "その他（" + users[i].menu_etc + "）"
              }
            }
          }

          db.ref('chat').orderByChild('createdAt').on('value', snapshot => {
            const messages = snapshot.val()
            //console.log(messages)

            // ユーザーごとに最後のメッセージ見つけてusersに追加
            for( let m in messages ) {
              for( let i in users ) {
                users[i]["subscription"] = true
                if (users[i]["id"] === m) {
                  for( let n in messages[m]["messages"] ) {
                    if (messages[m]["messages"][n]["contributor"] === "admin" || messages[m]["messages"][n]["contributor"] === "user") {
                      users[i]["last_message_date"] = messages[m]["messages"][n]["createdAt"];
                      users[i]["last_message"] = messages[m]["messages"][n]["message"];
                    }
                  }
                }
              }
            }

            // LP登録ユーザーの情報を見つけてusersに追加
            db.ref('lp/users').orderByChild("delete").equalTo(null).on('value', snapshot => {
              var lp_users = snapshot.val()
              for(let i in lp_users) {
                lp_users[i]["id"] = i
                lp_users[i]["ref"] = "lp/users/" + i
                if (!lp_users[i].attribute) {
                  lp_users[i]["attribute"] = "0"
                }
                if (lp_users[i].menu_etc) {
                  if ("" !== lp_users[i]["menu"]) {
                    lp_users[i]["menu"] += "、"
                  }
                  lp_users[i]["menu"] += "その他（" + lp_users[i].menu_etc + "）"
                }
                users.push(lp_users[i]);
              }

              var checks = {}
              for(let i in users) {
                checks[users[i].id] = false
              }

              var csv = _.cloneDeep(users);
              for(let i in csv) {
                csv[i]["createdAt"] = moment(csv[i]["createdAt"]).format('YYYY/MM/DD HH:mm')
                csv[i]["age"] = signups["age"][csv[i]["age"]]
                csv[i]["children"] = signups["children"][csv[i]["children"]]
                csv[i]["cleaning_frequency"] = signups["cleaning_frequency"][csv[i]["cleaning_frequency"]]
                csv[i]["family"] = signups["family"][csv[i]["family"]]
                csv[i]["pet"] = signups["pet"][csv[i]["pet"]]
                csv[i]["sex"] = signups["sex"][csv[i]["sex"]]
                if (csv[i]["family_name"]) {
                  csv[i]["name"] = csv[i]["family_name"] + " " + csv[i]["first_name"]
                  csv[i]["name_kana"] = csv[i]["family_name_kana"] + " " + csv[i]["first_name_kana"]
                }
                if (csv[i]["frequency"]) {
                  csv[i]["frequency"] = "週" + csv[i]["frequency"] + "回"
                }
                if (csv[i]["use"]) {
                  csv[i]["use"] = csv[i]["use"] + "回"
                }
                if (lots.find(lot => parseInt(lot.value, 10) === parseInt(csv[i]["lot"], 10))) {
                  csv[i]["lot"] = lots.find(lot => parseInt(lot.value, 10) === parseInt(csv[i]["lot"], 10)).label
                } else if (csv[i]["lot"]) {
                  csv[i]["lot"] = lots[csv[i]["lot"]].label
                }

                if (csv[i]["schedule"]) {
                  if (typeof csv[i]["schedule"] === "object") {
                    let schedule = ""
                    for (let n in schedule_mst) {
                      if (csv[i]["schedule"][n]["disabled"] === false) {
                        if (schedule !== "") {
                          schedule += ", "
                        }
                        schedule += schedule_mst[n] + "（" + csv[i]["schedule"][n]["time"][0] + ":00〜" + csv[i]["schedule"][n]["time"][1] + ":00）"
                      }
                    }
                    csv[i]["schedule"] = schedule
                  }
                }
              }

              scope.setState({ users: users, users_tmp: users, csv: csv, checks: checks })
            });
          });
        });

        scope.getMessage(scope.state.user_id)
      }
    });
  }

  getMessage (id) {
    db.ref('chat/' + id + '/messages').on('value', snapshot => {
      const messages = _.values(snapshot.val())
      //console.log(list)
      this.setState({ messages })
    });
    db.ref('emails/' + id + '/messages').on('value', snapshot => {
      const emails = _.values(snapshot.val())
      //console.log(list)
      this.setState({ emails })
    });
    db.ref('reservations/' + id).orderByChild('createdAt').on('value', snapshot => {
      const reservations = snapshot.val()
      var reservations_tmp = []
      for (let key in reservations) {
        reservations_tmp.push(Object.assign({"id": key}, reservations[key]))
      }
      //console.log(reservations_tmp)
      this.setState({ reservations: reservations_tmp })
    });
    db.ref('payments/' + id).on('value', snapshot => {
      const payments = _.values(snapshot.val())
      // 並べ替え（capturedAtがあるものを後ろにしつつ、capturedAtの昇順にする）
      let payments_tmp1 = []
      let payments_tmp2 = []
      for (let i in payments) {
        if (!payments[i].capturedAt) {
          payments_tmp1.push(payments[i])
        }
      }
      for (let i in payments) {
        if (payments[i].capturedAt) {
          payments_tmp2.push(payments[i])
        }
      }
      payments_tmp2 = payments_tmp2.sort(function(a, b) {
        return (a.capturedAt < b.capturedAt) ? -1 : 1;
      });
      //console.log(list)
      this.setState({ payments: payments_tmp1.concat(payments_tmp2) })
    });
  }

  changeSubMenu (menu_name) {
    this.setState({submenu: menu_name})
  }

  changeUser(user, id, name) {
    this.setState({ user: user, user_id: id, user_name: name })
    this.getMessage(id)
  }

  deleteUser(name, ref) {
    console.log(ref)
    if (window.confirm('ユーザー「' + name + '」を削除しますか？')) {

      var data = {
        delete: true,
        deletedAt: Date.now()
      }

      db.ref(ref).update(data).then(function() {// Update successful.
        //window.location.href = process.env.REACT_APP_PUBLIC_URL + "/admin_pre_users";
        window.location.href = "admin_users";
      }).catch(function (error) {
        // An error happened.
      });
    }
  }

  alt (e) {
    if (e) {
      var v = {}
      if ("DIV" === e.target.tagName) {
        v = {alt: true, alt_text: e.target.innerHTML, alt_x: e.currentTarget.getBoundingClientRect().left + 20, alt_y: e.currentTarget.getBoundingClientRect().top - 25}
        if (e.currentTarget.offsetWidth <= stringWidth(e.target.innerHTML) * 7.7) {
          this.handle = setTimeout(() => {
            this.setState(v)
          }, 300)
        }
      } else {
        v = {alt: true, alt_text: e.currentTarget.dataset.alt, alt_x: e.currentTarget.getBoundingClientRect().left + 10, alt_y: e.currentTarget.getBoundingClientRect().top - 25}
        this.handle = setTimeout(() => {
          this.setState(v)
        }, 300)
      }
    } else {
      clearTimeout(this.handle);
      this.setState({alt: false})
    }
  }

  editUser() {
    console.log(1)
  }

  setUserInfo(obj) {
    var user = this.state.user
    let k = Object.keys(obj)
    let v = Object.values(obj)
    user[k[0]] = v[0]
    if (k[0] === "menu") {
      user["menu_etc"] = ""
    }
    user["editing"] = 1
    this.setState({user: user})
  }

  editConfirm(id) {
    var data = _.cloneDeep(this.state.user);
    data.adminUpdatedAt = Date.now();

    var user_info = {
      id: id,
      family_name: data.family_name,
      first_name: data.first_name,
      family_name_kana: data.family_name_kana,
      first_name_kana: data.first_name_kana,
      zipcode: data.zipcode,
      address: data.address,
      apartment: data.apartment,
      tel: data.tel,
      email: data.email,
      age: parseInt(data.age, 10),
      sex: parseInt(data.sex, 10),
      family: parseInt(data.family, 10),
      cleaning_frequency: parseInt(data.cleaning_frequency, 10),
      children: parseInt(data.children, 10),
      pet: parseInt(data.pet, 10),
      menu: data.menu,
      schedule: data.schedule,
      attribute: data.attribute,
      adminUpdatedAt: data.adminUpdatedAt
    }

    if (data.attribute) {
      user_info["attribute"] = data.attribute
    }
    if (data.use) {
      user_info["use"] = parseInt(data.use, 10)
    }
    if (void 0 !== data.menu_etc) {
      user_info["menu_etc"] = data.menu_etc
    }
    if (void 0 !== data.memo) {
      user_info["memo"] = data.memo
    }

    console.log(user_info)

    db.ref(data.ref).update(user_info).then(function() {// Update successful.
      //window.location.href = process.env.REACT_APP_PUBLIC_URL + "/admin_pre_users";
      window.location.href = "admin_users";
    }).catch(function (error) {
      // An error happened.
    });
    
  }

  casts() {
    return this.state.casts.map(cast => {
      /*
      let ret
      
      // 同日同時刻で当キャストに予約が入っている場合、スキップ
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").unix() * 1000 && v.cast_id === cast.id) !== void 0) {
        return ret
      }
      // 予約済み時間数によって日付減算
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").subtract(30, 'minutes').unix() * 1000 && v.cast_id === cast.id && v.lot === "60") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").subtract(30, 'minutes').unix() * 1000 && v.cast_id === cast.id && v.lot === "90") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").subtract(30, 'minutes').unix() * 1000 && v.cast_id === cast.id && v.lot === "120") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").subtract(60, 'minutes').unix() * 1000 && v.cast_id === cast.id && v.lot === "90") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").subtract(60, 'minutes').unix() * 1000 && v.cast_id === cast.id && v.lot === "120") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").subtract(90, 'minutes').unix() * 1000 && v.cast_id === cast.id && v.lot === "120") !== void 0) {
        return ret
      }
      // 予約予定時間数によって日付加算
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").add(30, 'minutes').unix() * 1000 && v.cast_id === cast.id && this.state.lot === "60") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").add(30, 'minutes').unix() * 1000 && v.cast_id === cast.id && this.state.lot === "90") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").add(30, 'minutes').unix() * 1000 && v.cast_id === cast.id && this.state.lot === "120") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").add(60, 'minutes').unix() * 1000 && v.cast_id === cast.id && this.state.lot === "90") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").add(60, 'minutes').unix() * 1000 && v.cast_id === cast.id && this.state.lot === "120") !== void 0) {
        return ret
      }
      if (this.state.reservations.find((v) => v.date === moment(this.state.date + " " + this.state.time, "YYYY/MM/DD HH:mm").add(90, 'minutes').unix() * 1000 && v.cast_id === cast.id && this.state.lot === "120") !== void 0) {
        return ret
      }
      
      // 曜日を洗い出し
      let weekday = weekday_mst[moment(this.state.date, "YYYY/MM/DD").format("E")]
      // 時間を洗い出し
      let times = this.state.time.split(':');
      // 曜日、時間がキャスト的にOKか判定、NGの場合スキップ
      if (cast.schedule !== void 0) {
        if (cast.schedule[weekday].disabled === true) {
          return ret
        } else if (cast.schedule[weekday].time[0] > parseInt(times[0], 10) || cast.schedule[weekday].time[1] < parseInt(times[0], 10)) {
          return ret
        }
      }
      */

      let name = cast.name
      if (name === void 0) {
        name = cast.lastName + " *氏名未登録"
      }
      return <option key={cast.id} value={cast.id}>{name}</option>;
    })
  }

  send(user_id, message) {
    console.log("send ", user_id, " ", message)

    var line_send_url = process.env.REACT_APP_FUNCTIONS_URL + "/send"
    var options = {
      uri: line_send_url,
      headers: {
        "Content-type": "application/json",
      },
      json: {
        "user_id": user_id,
        "message": message
      }
    }

    var scope = this
    request.post(options, function(error, response, body){
      scope.setState({message: ""})
    });
  }

  changeTemplate(k) {
    console.log(k, user_templates)
    if (k) {
      this.setState({mail_title: user_templates[k].subject, mail_body: user_templates[k].body})
    }
  }

  mailSend(user_id) {
    var sendgrid_url = process.env.REACT_APP_FUNCTIONS_URL + "/email"

    var ids = []
    var emails = []
    if (user_id) {
      ids.push(this.state.user.id)
      emails.push(this.state.user.email)
    } else {
      for (let i = 0; i < this.state.sends.length; i++) {
        ids.push(this.state.sends[i].id)
        emails.push(this.state.sends[i].email)
      }
      this.setState({sends: []})
    }

    //console.log(emails)

    var options = {
      uri: sendgrid_url,
      headers: {
        "Content-type": "application/json",
      },
      json: {
        "ids": ids,
        "emails": emails,
        "subject": this.state.mail_title,
        "body": this.state.mail_body
      }
    }

    var scope = this
    request.post(options, function(error, response, body){
      scope.setState({mail_title: "", mail_body: ""})
    });
  }

  getCustomer(user_id, token_id, attribute, customer_id) {
    //console.log(options)
    return new Promise((resolve, reject)=>{
      if (customer_id) {
        resolve(customer_id);
      } else {
        var scope = this
        var payment_url = process.env.REACT_APP_FUNCTIONS_URL + "/payment"
        var alias = ""
        if (attribute === "0") {
          alias = "lp/"
        }
        var options = {
          uri: payment_url,
          headers: {
            "Content-type": "application/json",
          },
          json: {
            "user_id": user_id,
            "token_id": token_id,
            "alias": alias
          }
        }
        request.post(options, function(error, response, body){
          //console.log(body)
          if (error) {
            reject("サーバーとの通信に失敗しました。大変お手数ですが、数分後に再度やり直してください");
          } else {
            if (body.status === "error") {
              reject(body.message);
            } else {
              let user = scope.state.user
              user.card = {customer_id: body.customer_id}
              scope.setState({user:user})
              resolve(body.customer_id);
            }
          }
        });
      }
    });
  }

  reservationSend(user_id) {
    var scope = this
    if (window.confirm('この内容で予約を確定しますか？')) {

      var customer_id = ""
      if (scope.state.user.card) {
        customer_id = scope.state.user.card.customer_id
      }

      // 顧客情報があるか？
      scope.getCustomer(user_id, scope.state.user.payjp_id, scope.state.user.attribute, customer_id).then(async (customer_id) => {

          var reservation_id = db.ref(`reservations/` + user_id).push().key
          

          // 決済（オーソリ）
          var payment_url = process.env.REACT_APP_FUNCTIONS_URL + "/payment"
          var options = {
            uri: payment_url,
            headers: {
              "Content-type": "application/json",
            },
            json: {
              "user_id": user_id,
              "reservation_id": reservation_id,
              "customer_id": customer_id,
              "amount": scope.state.price
            }
          }
          await request.post(options, function(error, response, body) {
            console.log("response", response);
            console.log("body", body["status"]);
            
            let message = ""
            if (body["message"]) {
              message = body["message"]
            }

            // オーソリ通ればDB登録
            var data = {
              menu: scope.state.menu,
              date: moment(scope.state.date + " " + scope.state.time).unix() * 1000,
              lot: scope.state.lot,
              price: scope.state.price,
              cast_id: scope.state.cast_id,
              createdAt: Date.now(),
              payment_status: body["status"],
              payment_message: message
            }

            //console.log(data)

            db.ref(`reservations/` + user_id + "/" + reservation_id).update(data).then(function() {
              //scope.getMessage(user_id)

              db.ref('reservations/' + user_id).on('value', snapshot => {
                const reservations = snapshot.val()
                var reservations_tmp = []
                for (let key in reservations) {
                  reservations_tmp.push(Object.assign({"id": key}, reservations[key]))
                }
                //console.log(reservations_tmp)
                scope.setState({ reservations: reservations_tmp })
                db.ref('payments/' + user_id).on('value', snapshot => {
                  const payments = _.values(snapshot.val())
                  let payments_tmp1 = []
                  let payments_tmp2 = []
                  for (let i in payments) {
                    if (!payments[i].capturedAt) {
                      payments_tmp1.push(payments[i])
                    }
                  }
                  for (let i in payments) {
                    if (payments[i].capturedAt) {
                      payments_tmp2.push(payments[i])
                    }
                  }
                  payments_tmp2 = payments_tmp2.sort(function(a, b) {
                    return (a.capturedAt < b.capturedAt) ? -1 : 1;
                  });
                  //console.log(list)
                  scope.setState({ payments: payments_tmp1.concat(payments_tmp2) })
                });
              });
            });
          })
      });
    }
  }

  paymentSend(user_id, reservation) {
    var scope = this
    console.log(user_id, reservation)

    var charge_id = this.state.payments.find(payment => payment.reservation_id === reservation.id).charge_id
    
    var payment_url = process.env.REACT_APP_FUNCTIONS_URL + "/payment"
    var options = {
      uri: payment_url,
      headers: {
        "Content-type": "application/json",
      },
      json: {
        "user_id": user_id,
        "charge_id": charge_id,
        "capture": true
      }
    }

    console.log(options)

    request.post(options, function(error, response, body){
      console.log(body.message)
      db.ref("reservations/" + user_id + "/" + reservation.id).update({payment_status: "done"}).then(function() {
        //scope.getMessage(user_id);

        db.ref('reservations/' + user_id).on('value', snapshot => {
          const reservations = snapshot.val()
          var reservations_tmp = []
          for (let key in reservations) {
            reservations_tmp.push(Object.assign({"id": key}, reservations[key]))
          }
          //console.log(reservations_tmp)
          scope.setState({ reservations: reservations_tmp })
          db.ref('payments/' + user_id).on('value', snapshot => {
            const payments = _.values(snapshot.val())
            let payments_tmp1 = []
            let payments_tmp2 = []
            for (let i in payments) {
              if (!payments[i].capturedAt) {
                payments_tmp1.push(payments[i])
              }
            }
            for (let i in payments) {
              if (payments[i].capturedAt) {
                payments_tmp2.push(payments[i])
              }
            }
            payments_tmp2 = payments_tmp2.sort(function(a, b) {
              return (a.capturedAt < b.capturedAt) ? -1 : 1;
            });
            //console.log(list)
            scope.setState({ payments: payments_tmp1.concat(payments_tmp2) })
          });
        });
      });
    });
    
  }

  changeStateFromChild (e) {
    this.setState(e)
  }

  handleScroll = (e) => {
    //console.log(e.target.scrollHeight, Math.ceil(e.target.scrollTop), e.target.clientHeight)
    const bottom = e.target.scrollHeight - Math.ceil(e.target.scrollTop) <= e.target.clientHeight;
    if (bottom) {
      //console.log("bottom");
      var view_num = this.state.view_num + 100
      this.setState({view_num: view_num})
    }
  }

  render () {
    moment.updateLocale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
    const user_list = this.state.users.map(user => {
      let name = user.lastName
      if (user.family_name) {
        name = user.family_name + " " + user.first_name
      }
      return <li key={user.id} className={[user.id === this.state.user_id ? "user active" : "user"]} onClick={e => this.changeUser(user, user.id, name)}>
        <img src={user.picture} alt="" className="profile" height="30" />
        <div>
          <p className="message_date">{moment(user.last_message_date, "YYYY/MM/DD").format('YYYY/MM/DD')}</p>
          <p className="user_name">{name}</p>
          <p className="message_summary">{user.last_message ? user.last_message.substr(0, 15) : ""}...</p>
        </div>
      </li>
      ;
    });

    const user_detail_list = this.state.users.slice(0, this.state.view_num).map(user => {
      let ret
      let name = user.lastName
      if (user.family_name) {
        name = user.family_name + " " + user.first_name
      }
      ret = <li key={user.id} className={[user.id === this.state.user_id ? "user active" : "user"]} onClick={e => this.changeUser(user, user.id, name)} onDoubleClick={e => this.changeSubMenu("operation")}>
        <div><img alt="□" src={"/images/check_" + this.state.checks[user.id] + ".png"} onClick={e => addCheck(user.id, name, user.email, this.state.users, this.state.sends, this.state.checks, this.state.all_check, (callback) => {this.setState(callback)})} className="checkbox_image" /></div>
        <div><span className={[user.attribute === "0" ? "cp" : ""]}>{attribute_mst[user.attribute]}</span></div>
        <div><img src={user.picture ? user.picture : "/images/user.png"} alt="" className="profile" height="30" /></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{name}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.address}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.apartment}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source"></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.tel}</div>
        <div><a href={"mailto:" + user.email}>{user.email}</a></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.menu}</div>
        <div>{moment(user.createdAt).format('MM/DD(dddd) HH:mm')}</div>
        <div></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{user.memo}</div>
        <div>
          <p data-alt="編集" onClick={e => this.editUser()} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faPencilAlt} /></p>
          <p data-alt="削除" onClick={e => deleteRecord(name, user.ref, "/admin_users", db)} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faTrash} /></p>
          <p data-alt="オペレーション" onClick={e => this.changeSubMenu("operation")} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faArrowAltCircleRight} /></p>
        </div>
      </li>
      ;
      return ret
    });

    const message_list = this.state.messages.map((message, i) => {
      let ret
      if (message.contributor === "admin" || message.contributor === "user") {
        ret = <li key={i} className="message-data">
          <div>
            <p className="message_date">{moment(message.createdAt).format('YYYY/MM/DD(dddd)HH:mm')}</p>
            <p className="message_body"><span>{[message.contributor === "admin" ? "あなた：" : ""]}</span>{message.message}</p>
          </div>
        </li>
        ;
      }
      return ret
    });

    const email_list = this.state.emails.map((email, i) => {
      return <li key={i} className="email-data">
        <div>
          <p className="email_subject">{email.subject}<span className="email_date">{moment(email.createdAt).format('YYYY/MM/DD(dddd)HH:mm')}</span></p>
          <p className="email_body">{email.body}</p>
        </div>
      </li>
      ;
    });

    const template_list = user_templates.map((template, i) => {
      return <option key={i} value={i}>{template.title}</option>;
    });

    const reservation_list = this.state.reservations.map((reservation, i) => {
      let ret
      if (reservation.menu) {
        let carry_out = <span>実施予定　</span>
        if (reservation.date < Date.now()) {
          carry_out = <span>実施済み　</span>
        }
        let cast_name
        if (this.state.casts) {
          cast_name = this.state.casts.find(cast => cast.id === reservation.cast_id).name + "にて実施"
        }
        let payment
        if (reservation.date < Date.now()) {
          if (reservation.payment_status === "done") {
            payment = <span>決済済み</span>
          } else if (reservation.payment_status === "error") {
            payment = <span>決済時エラー（{reservation.payment_message}）</span>
          } else {
            payment = <button onClick={e => this.paymentSend(this.state.user_id, reservation)}>決済</button>
          }
        }
        ret = <li key={i} className="reservation-data">
          <div>
            <p className="reservation_date">{moment(reservation.date).format('YYYY/MM/DD(dddd)HH:mm')}</p>
            <p className="reservation_body">{carry_out}{menus.find(menu => menu.id === reservation.menu).title} {lots.find(lot => lot.value === reservation.lot).label} {cast_name} {payment}</p>
          </div>
        </li>
        ;
      }
      return ret
    });

    const payment_list = this.state.payments.map((payment, i) => {
      let capture = <span>オーソリ（未決済）</span>
      if (payment.capture === true) {
        capture = <span>決済済み</span>
      }
      let payment_date = <span>{moment(payment.createdAt * 1000).format('YYYY/MM/DD(dddd)HH:mm')}</span>
      if (payment.capturedAt) {
        payment_date = <span>{moment(payment.capturedAt * 1000).format('YYYY/MM/DD(dddd)HH:mm')}</span>
      }
      return <li key={i} className="payment-data">
        <div>
          <p className="payment_date">{payment_date}</p>
          <p className="payment_detail">[{payment.card_brand}] **** **** **** {payment.card_last4}（有効期限 {payment.card_exp_year}/{payment.card_exp_month}）</p>
          <p className="payment_overview">{payment.amount}円（Payjp売上ID {payment.charge_id}）</p>
          <p>{capture}</p>
        </div>
      </li>
      ;
    });

    const send_list = this.state.sends.map((user, i) => {
      return <li key={i}>{user.name} {user.email}</li>
    });

    const user_info = () => {
      if (this.state.user_id) {
        let user_attribute_text = <span className={[this.state.user.attribute === "0" ? "cp" : ""]}>{attribute_mst[this.state.user.attribute]}利用ユーザー</span>
        let menu = this.state.user.menu
        if (this.state.user.campaign) {
          menu = <span>{this.state.user.menu}（{this.state.user.campaign}）</span>
        }
        let use = ""
        if (this.state.user.use) {
          use = <span>{this.state.user.use}回</span>
        }
        let lot = ""
        if (this.state.user.lot) {
          lot = <span>{this.state.user.lot}分</span>
        }
        let schedule = this.state.user.schedule
        if (typeof schedule === "object") {
          schedule = ""
          for (let i in schedule_mst) {
            if (this.state.user.schedule) {
              if (this.state.user.schedule[i]["disabled"] === false) {
                if (schedule !== "") {
                  schedule += ", "
                }
                schedule += schedule_mst[i] + "（" + this.state.user.schedule[i]["time"][0] + ":00〜" + this.state.user.schedule[i]["time"][1] + ":00）"
              }
            }
          }
        }
        let card = <ul><li>未登録</li></ul>
        if (this.state.user.payjp_id) {
          card = <ul>
            <li>{this.state.user.payjp_id}</li>
          </ul>
        }
        return <div className="information-contents-wrapper">
          <div className="picture-center"><img src={this.state.user.picture} alt="" className="profile" height="80" /></div>
          <p className="user_name">{this.state.user.family_name} {this.state.user.first_name}</p>
          <p className="user_attribute">{user_attribute_text}</p>
          <p className="info-title">ユーザー基本情報</p>
          <ul>
            <li>User ID:{this.state.user.id}</li>
            <li>{this.state.user.family_name} {this.state.user.first_name}（{this.state.user.family_name_kana} {this.state.user.first_name_kana}）</li>
            <li>{signups["age"][this.state.user.age]} {signups["sex"][this.state.user.sex]} {signups["family"][this.state.user.family]}</li>
            <li>{this.state.user.tel}</li>
            <li><a href={"mailto:" + this.state.user.email}>{this.state.user.email}</a></li>
            <li>〒{this.state.user.zipcode} {this.state.user.address} {this.state.user.apartment}</li>
            <li>掃除頻度 {signups["cleaning_frequency"][this.state.user.cleaning_frequency]}</li>
            <li>子供 {signups["children"][this.state.user.children]}</li>
            <li>ペット {signups["pet"][this.state.user.pet]}</li>
          </ul>
          <p className="info-title">希望メニュー情報</p>
          <ul>
            <li>{menu}</li>
            <li>{use}</li>
            <li>{lot}</li>
            <li>{schedule}</li>
          </ul>
          <p className="info-title">定期予約情報</p>
          <ul>
            <li></li>
          </ul>
          <p className="info-title">クレジットカード情報</p>
          {card}
        </div>
        ;
      }
    }

    const age_list = signups.age.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const sex_list = signups.sex.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const family_list = signups.family.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const cleaning_frequency_list = signups.cleaning_frequency.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const children_list = signups.children.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });
    const pet_list = signups.pet.map((v, i) => {
      return <option key={i} value={i}>{v}</option>;
    });

    const user_edit = () => {
      if (this.state.user_id) {
        let schedule = this.state.user.schedule
        if (typeof schedule === "object") {
          schedule = ""
          for (let i in schedule_mst) {
            if (this.state.user.schedule) {
              if (this.state.user.schedule[i]["disabled"] === false) {
                if (schedule !== "") {
                  schedule += ", "
                }
                schedule += schedule_mst[i] + "（" + this.state.user.schedule[i]["time"][0] + ":00〜" + this.state.user.schedule[i]["time"][1] + ":00）"
              }
            }
          }
        }
        return <div className="information-contents-wrapper">
          <dl>
            <dt>ユーザータイプ</dt><dd><select name="attribute" value={this.state.user.attribute} onChange={e => this.setUserInfo({attribute: e.target.value})}>
              <option value="0">CP利用ユーザー</option>
              <option value="1">定期利用ユーザー</option>
            </select></dd>
            <dt>氏名</dt><dd><input type="text" name="family_name" className="input-s" value={this.state.user.family_name} onChange={e => this.setUserInfo({family_name: e.target.value})} placeholder="山田" /><input type="text" name="first_name" className="input-s" value={this.state.user.first_name} onChange={e => this.setUserInfo({first_name: e.target.value})} placeholder="花子" /></dd>
            <dt>フリガナ</dt><dd><input type="text" name="family_name_kana" className="input-s" value={this.state.user.family_name_kana} onChange={e => this.setUserInfo({family_name_kana: e.target.value})} placeholder="ヤマダ" /><input type="text" name="first_name_kana" className="input-s" value={this.state.user.first_name_kana} onChange={e => this.setUserInfo({first_name_kana: e.target.value})} placeholder="ハナコ" /></dd>
            <dt>年齢</dt><dd><select name="age" value={this.state.user.age} onChange={e => this.setUserInfo({age: e.target.value})}>{age_list}</select></dd>
            <dt>性別</dt><dd><select name="sex" value={this.state.user.sex} onChange={e => this.setUserInfo({sex: e.target.value})}>{sex_list}</select></dd>
            <dt>家族構成</dt><dd><select name="sex" value={this.state.user.family} onChange={e => this.setUserInfo({family: e.target.value})}>{family_list}</select></dd>
            <dt>電話番号</dt><dd><input type="text" name="tel" value={this.state.user.tel} onChange={e => this.setUserInfo({tel: e.target.value})} placeholder="090-1234-5678" /></dd>
            <dt>メールアドレス</dt><dd><input type="text" name="email" value={this.state.user.email} onChange={e => this.setUserInfo({email: e.target.value})} placeholder="yamada@gmail.com" /></dd>
            <dt>郵便番号</dt><dd><input type="text" name="zipcode" value={this.state.user.zipcode} onChange={e => this.setUserInfo({zipcode: e.target.value})} placeholder="123-4567" /></dd>
            <dt>住所</dt><dd><input type="text" name="address" value={this.state.user.address} onChange={e => this.setUserInfo({address: e.target.value})} placeholder="東京都千代田区神田猿楽町１丁目２−２" /></dd>
            <dt>マンション名</dt><dd><input type="text" name="apartment" value={this.state.user.apartment} onChange={e => this.setUserInfo({apartment: e.target.value})} placeholder="ザ・パークハウスアーバンス千代田御茶ノ水" /></dd>
            <dt>掃除頻度</dt><dd><select name="cleaning_frequency" value={this.state.user.cleaning_frequency} onChange={e => this.setUserInfo({cleaning_frequency: e.target.value})}>{cleaning_frequency_list}</select></dd>
            <dt>子供</dt><dd><select name="children" value={this.state.user.children} onChange={e => this.setUserInfo({children: e.target.value})}>{children_list}</select></dd>
            <dt>ペット</dt><dd><select name="pet" value={this.state.user.pet} onChange={e => this.setUserInfo({pet: e.target.value})}>{pet_list}</select></dd>
            <dt>希望の掃除内容</dt><dd><div className="menu_list"><input type="text" value={this.state.user.menu} onChange={e => this.setUserInfo({menu: e.target.value})} /></div></dd>
            <dt>希望の回数</dt><dd><select name="use" value={this.state.user.use} onChange={e => this.setUserInfo({use: e.target.value})}>
              <option value="">未選択</option>
              <option value="1">1回</option>
              <option value="2">2回</option>
              <option value="3">3回</option>
              <option value="4">4回</option>
            </select></dd>
            <dt>希望の曜日・時間</dt><dd><div className="schedule_list"><textarea value={schedule} onChange={e => this.setUserInfo({schedule: e.target.value})} /></div></dd>
            <dt>顧客メモ</dt><dd><textarea value={this.state.user.memo} onChange={e => this.setUserInfo({memo: e.target.value})} /></dd>
          </dl>
        </div>
        ;
      }
    }

    const dates = [];
    moment.updateLocale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
    for (let i = 0; i <= 30; i++) {
      dates.push(
        <option key={i} value={moment().add(i, 'days').format('YYYY/MM/DD')}>{moment().add(i, 'days').format('YYYY年MM月DD日(dddd)')}</option>
      )
    }

    const lot_list = lots.map(lot => {
      return <option key={lot.value} value={lot.value}>{lot.label}</option>;
    });

    const reservation_menu_list = menus.map(menu => {
      return <option key={menu.id} value={menu.id}>{menu.title}</option>
    });

    return <div className="admin">
    <Header />
      <div className="admin-sub-menus">
        <ul>
          <li className={ this.state.submenu === "lists" ? "active" : "" } onClick={e => this.changeSubMenu("lists")}>ユーザー一覧</li>
          <li className={ this.state.submenu === "operation" ? "active" : "" } onClick={e => this.changeSubMenu("operation")}>オペレーション</li>
        </ul>
      </div>
      <div className="admin-contents-wrapper" onScroll={this.handleScroll}>
        <div className={ this.state.submenu === "lists" ? "admin-user-lists active" : "admin-user-lists" }>
          <div className={ this.state.alt === true ? "alt show" : "alt hide" } style={{ top: this.state.alt_y, left: this.state.alt_x }}>{this.state.alt_text}</div>
          <ul className="user-list-menu">
            <li><img alt="□" src={"/images/check_" + this.state.all_check + ".png"} onClick={e => allCheck(this.state.all_check, this.state.users, (callback) => {this.setState(callback)})} className="checkbox_image" /></li>
            <li onClick={e => this.changeSubMenu("operations")}><span><FontAwesomeIcon icon={faEnvelope} />送信</span></li>
            <li><span><FontAwesomeIcon icon={faTrash} />削除</span></li>
            <li><span><FontAwesomeIcon icon={faFileCsv} /><CSVLink data={this.state.csv} headers={csv_headers}>ダウンロード</CSVLink></span></li>
            <li><Filter state={this.state} onChange={e => this.changeStateFromChild(e)} /></li>
          </ul>
          <ul className="user-list">
            <li className="user-list-title">
              <div></div>
              <div>属性</div>
              <div>画像</div>
              <div>氏名</div>
              <div>住所</div>
              <div>マンション</div>
              <div>最寄駅</div>
              <div>電話番号</div>
              <div>メールアドレス</div>
              <div>メニュー</div>
              <div>登録日</div>
              <div>担当</div>
              <div>メモ</div>
              <div>管理</div>
            </li>
            {user_detail_list}
          </ul>
        </div>

        <div className={ this.state.submenu === "operation" ? "admin-user-operation active" : "admin-user-operation" }>
          <ul className="side-menu">
            <Filter state={this.state} onChange={e => this.changeStateFromChild(e)} />
            <div className="side-list">
              {user_list}
            </div>
          </ul>
          <div className="right-informations">
            {user_info()}
          </div>
          <div className="admin-contents messages">
            <div className="user-operation-menu">
              <ul>
                <li className={ this.state.contentmenu === "message" ? "active" : ""} onClick={e => this.setState({contentmenu: "message"})}>メッセージ</li>
                <li className={ this.state.contentmenu === "email" ? "active" : ""} onClick={e => this.setState({contentmenu: "email"})}>メール</li>
                <li className={ this.state.contentmenu === "reservation" ? "active" : ""} onClick={e => this.setState({contentmenu: "reservation"})}>利用</li>
                <li className={ this.state.contentmenu === "payment" ? "active" : ""} onClick={e => this.setState({contentmenu: "payment"})}>決済</li>
                <li className={ this.state.contentmenu === "edit" ? "active" : ""} onClick={e => this.setState({contentmenu: "edit"})}>情報編集</li>
              </ul>
              <br className="clear" />
            </div>
            <ul className={ this.state.contentmenu === "message" ? "chat-history active" : "chat-history"}>
              {message_list}
            </ul>
            <ul className={ this.state.contentmenu === "email" ? "email-history active" : "email-history"}>
              {email_list}
            </ul>
            <ul className={ this.state.contentmenu === "reservation" ? "reservation-history active" : "reservation-history"}>
              {reservation_list}
            </ul>
            <ul className={ this.state.contentmenu === "payment" ? "payment-history active" : "payment-history"}>
              {payment_list}
            </ul>
            <ul className={ this.state.contentmenu === "edit" ? "user-edit active" : "user-edit"}>
              {user_edit()}
            </ul>
          </div>
          <div className={ this.state.contentmenu === "message" ? "chat" : "chat hide"} >
            <textarea placeholder="ユーザーにLINEメッセージを送信" value={this.state.message} onChange={e => this.setState({message: e.target.value})} />
            <button onClick={e => this.send(this.state.user_id, this.state.message)} value>送信</button>
          </div>
          <div className={ this.state.contentmenu === "email" ? "email" : "email hide"} >
            <input type="text" placeholder="件名" value={this.state.mail_title} onChange={e => this.setState({mail_title: e.target.value})} />
            <textarea placeholder="本文" value={this.state.mail_body} onChange={e => this.setState({mail_body: e.target.value})} />
            <select onChange={e => this.changeTemplate(e.target.value)}>
              <option value="">テンプレートを利用</option>
              {template_list}
            </select>
            <button onClick={e => this.mailSend(this.state.user_id)} value>送信</button>
          </div>
          <div className={ this.state.contentmenu === "reservation" ? "reservation" : "reservation hide"} >
            <div className="reservation-conditions">
              <select onChange={e => this.setState({date: e.target.value})}>
                {dates}
              </select>
              <select onChange={e => this.setState({time: e.target.value})}>
                <option value="9:00">9:00〜</option>
                <option value="9:30">9:30〜</option>
                <option value="10:00">10:00〜</option>
                <option value="10:30">10:30〜</option>
                <option value="11:00">11:00〜</option>
                <option value="11:30">11:30〜</option>
                <option value="12:00">12:00〜</option>
                <option value="12:30">12:30〜</option>
                <option value="13:00">13:00〜</option>
                <option value="13:30">13:30〜</option>
                <option value="14:00">14:00〜</option>
                <option value="14:30">14:30〜</option>
                <option value="15:00">15:00〜</option>
                <option value="15:30">15:30〜</option>
                <option value="16:00">16:00〜</option>
                <option value="16:30">16:30〜</option>
                <option value="17:00">17:00〜</option>
                <option value="17:30">17:30〜</option>
              </select>
              <select onChange={e => this.setState({lot: e.target.value})}>
                {lot_list}
              </select>
              <select onChange={e => this.setState({menu: e.target.value})}>
                {reservation_menu_list}
              </select>
              <select onChange={e => this.setState({cast_id: e.target.value})}>
                {this.casts()}
              </select>
              <div className="reservation-price">
                <input type="text" value={this.state.price} placeholder="金額" onChange={e => this.setState({price: e.target.value})} /><p>円</p>
              </div>
              {/*<select onChange={e => this.setState({period: e.target.value})}>
                <option value="0">スポット</option>
                <option value="1">毎週</option>
                <option value="2">隔週（1、3週）</option>
                <option value="3">隔週（2、4週）</option>
              </select>*/}
              <div className="reservation-caution">
                {this.state.caution}
              </div>
              <button onClick={e => this.reservationSend(this.state.user_id)} value>確定</button>
            </div>
          </div>

          <div className={ this.state.contentmenu === "edit" ? "user-edit" : "user-edit hide"} >
            <div className="reservation-conditions">
              <p>{this.state.user.editing === 1 ? "データ編集中(未確定)" : ""}</p>
              <button onClick={e => this.editConfirm(this.state.user_id)} value>更新</button>
            </div>
          </div>
        </div>

        <div className={ this.state.submenu === "operations" ? "admin-user-operations active" : "admin-user-operations" }>
          送付先:<ul>{send_list}</ul>
          <input type="text" placeholder="タイトル" value={this.state.mail_title} onChange={e => this.setState({mail_title: e.target.value})} /><br />
          <textarea placeholder="本文" value={this.state.mail_body} onChange={e => this.setState({mail_body: e.target.value})} /><br />
          <input type="button" value="送信" onClick={e => this.mailSend()} /><input type="button" value="キャンセル" onClick={e => this.changeSubMenu("lists")} />
        </div>
      </div>
    <Footer />
    </div>;
  }
}